exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiple-image-input[data-v-57ec485e] {\n    width: 150px;\n    height: 150px;\n}\n", ""]);

// exports
